module.exports = __webpack_public_path__ + "static/tab3-d67753bf450bb9179bcad5193e0c7ae5.jpg";